import React from 'react';
import { hot } from 'react-hot-loader';
import { purifier } from '../../../utils/dom';
import { urlify } from '../../../utils/string';
import s from './Heading.scss';

const Heading = ({ content, attrs = {}, setup }) => {
	const style = {};
	const HeadingTag = `h${content?.level || '2'}`;
	const headingClasses = [s.heading, (attrs.className ? attrs.className.map((cN) => s[`heading${cN}`]) : [])];
	if (attrs.textColor) style.color = attrs.textColor;
	if (attrs.textAlign) style.textAlign = attrs.textAlign;

	return (
		<div id={urlify(content.rawText)} className={headingClasses.join(' ')} style={style}>
			<HeadingTag className={[s.heading_inner, (attrs.fontSize ? `u_fontSize__${attrs.fontSize.replace(/(px)*$/, '')}` : null)].join(' ')} dangerouslySetInnerHTML={{ __html: purifier(content.rawText.replace(/®/g, '<span class="u_registered">®</span>'), {}, setup) }} />
		</div>
	);
};

export default hot(module)(Heading);
